import { render, staticRenderFns } from "./lotteryGold.vue?vue&type=template&id=21310cbb&scoped=true&"
import script from "./lotteryGold.vue?vue&type=script&lang=js&"
export * from "./lotteryGold.vue?vue&type=script&lang=js&"
import style0 from "./lotteryGold.vue?vue&type=style&index=0&id=21310cbb&prod&lang=less&"
import style1 from "./lotteryGold.vue?vue&type=style&index=1&id=21310cbb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21310cbb",
  null
  
)

export default component.exports